import {
  MessageStatus,
  waitForMessageReceived,
} from '@layerzerolabs/scan-client';
import { useEffect, useState } from 'react';
import { layerZeroChainIdsByChainId } from 'structure/bridge/constants/lazyerZeroChains';
import { TTransaction } from 'structure/bridge/store/transactionsAtom';

type Message = {
  status: MessageStatus;
  dstTxHash: `0x${string}`;
};

export function useLZMessage(transaction: TTransaction) {
  const [messageReceived, setMessageReceived] = useState(false);
  const [message, setMessage] = useState<Message>({
    status: MessageStatus.INFLIGHT,
    dstTxHash: '' as `0x${string}`,
  });

  useEffect(() => {
    let isSubscribed = true;

    waitForMessageReceived(
      layerZeroChainIdsByChainId[transaction.srcChainId],
      transaction.srcTxHash
    )
      .then((message) => {
        if (isSubscribed) {
          setMessageReceived(true);
          setMessage(message as Message);
        }
      })
      .catch((error) => {
        if (isSubscribed) {
          console.error('get message error', error);
        }
      });
    return () => {
      isSubscribed = false; // Prevent actions after component unmounts
    };
  }, [messageReceived, message, transaction.srcChainId, transaction.srcTxHash]);

  return { messageReceived, message };
}
